enum ReceiptDeliveryType {
  Unknown = 'unknown',
  Digital = 'digital',
  Printed = 'printed',
}

export default ReceiptDeliveryType;
